import React from 'react';
import useTranslation from 'Hooks/useTranslation';
import Title from 'Components/Title';
import Grid from '@mui/material/Grid';
import {
  Achievement1IconC,
  Achievement1IconNC,
  Achievement2IconC,
  Achievement2IconNC,
  Achievement3IconC,
  Achievement3IconNC,
  Achievement4IconC,
  Achievement4IconNC,
} from 'Images';
import CardUser from './Components/CardUser';
import BadgeCard from './Components/BadgeCard';
import { ContainerCards } from './style';
import useFetchAchievements from './Hooks/useFetchAchievements';

export default function Profile({ employee, isAdmin }) {
  const { t2 } = useTranslation('EmployeeAssess');
  const name = employee[1];
  const department = employee[2];
  const jobTitle = employee[3];
  const entryDate = employee[7];
  const status = employee[8];
  const payrollNum = employee[0];
  const terminal = employee[5];
  const id = employee[9];
  const role = employee[4];

  const { userAchievements } = useFetchAchievements({ userId: id });

  const achievements = [
    {
      name: 'Insignia Mexlog',
      description: 'Terminación de plan de desarrollo',
      completedIcon: Achievement1IconC,
      uncompletedIcon: Achievement1IconNC,
    },
    {
      name: 'Primer Éxito',
      description: 'Termina tu primer curso aprobatorio',
      completedIcon: Achievement2IconC,
      uncompletedIcon: Achievement2IconNC,
    },
    {
      name: 'Multidisciplinario',
      description: 'Termina un curso que no esté en tu plan de desarrollo',
      completedIcon: Achievement3IconC,
      uncompletedIcon: Achievement3IconNC,
    },
    {
      name: 'Insignia de Bienvenida',
      description: 'Ingresa a la aplicación por primera vez',
      completedIcon: Achievement4IconC,
      uncompletedIcon: Achievement4IconNC,
    },
  ];
  return (
    <div>
      <Title title={t2('Profile')} subtitle={t2('EmployeeProfile')} />
      <ContainerCards>
        <CardUser
          name={name}
          department={department}
          jobTitle={jobTitle}
          entryDate={entryDate}
          status={status}
          payrollNum={payrollNum}
          terminal={terminal}
          isAdmin={isAdmin}
          id={id}
          role={role}
        />
        <Grid container spacing={{ xs: 2 }} columns={{ xs: 6 }} style={{ marginLeft: '1rem' }}>
          {userAchievements &&
            userAchievements.map((userAchievement, index) => (
              <Grid item key={index}>
                <BadgeCard userAchievement={userAchievement} achievement={achievements[index]} />
              </Grid>
            ))}
        </Grid>
      </ContainerCards>
    </div>
  );
}
